export default "data:image/webp;base64,UklGRiQAAABXRUJQVlA4TBcAAAAvJ8AHAIVYMGHIHzaHXdM7Ff3P5jf8AAA="